/**
 * Property Filters
 *
 * Filters related to property characteristics: bedrooms, type, tenure
 * To add a new property filter, simply add a new object to this array
 */

import { Filter } from '../../types/filters';

export const propertyFilters: Filter[] = [
  // ===== BEDROOMS =====
  {
    id: 'bedrooms',
    name: 'Bedrooms',
    description: 'Number of bedrooms',
    category: 'property',
    type: 'checkbox',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 7,
    dataPath: 'source.bedrooms', // Available in source object
    version: '1.0',
    enabled: true,
    defaultValue: [],
    config: {
      options: [
        { value: '0', label: 'Studio', icon: '' },
        { value: '1', label: '1 Bed', icon: '' },
        { value: '2', label: '2 Bed', icon: '' },
        { value: '3', label: '3 Bed', icon: '' },
        { value: '4', label: '4+ Bed', icon: '' }
      ],
      defaultSelected: [],
      multiSelect: true
    }
  },

  // ===== PROPERTY TYPE =====
  {
    id: 'property_type',
    name: 'Property Type',
    description: 'Type of property',
    category: 'property',
    type: 'checkbox',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 8,
    dataPath: 'source.propertyType', // Available in source object
    version: '1.0',
    enabled: true,
    defaultValue: [],
    config: {
      options: [
        { value: 'Flat', label: 'Flat', icon: '' },
        { value: 'House', label: 'House', icon: '' },
        { value: 'Semi-Detached', label: 'Semi-Detached', icon: '' },
        { value: 'Detached', label: 'Detached', icon: '' },
        { value: 'Terraced', label: 'Terraced', icon: '' },
        { value: 'Bungalow', label: 'Bungalow', icon: '' },
        { value: 'Barn Conversion', label: 'Barn Conversion', icon: '' }
      ],
      defaultSelected: [],
      multiSelect: true
    }
  }
];
